module.exports = __webpack_public_path__ + "media/images/games/k2gender/catspr-5b42e98710f15f2b6553ebba9e0ff594.png";